<template>
  <v-container>
    <v-row justify="end" no-gutters>
      <TillSettings></TillSettings>
    </v-row>
    <v-row no-gutters justify="space-between" class="mb-1">
      <v-btn text dark color="success" :to="{ name: 'TillCreator' }">
        <v-icon small left>fa-plus</v-icon>
        Nouveau Balancement
      </v-btn>
      <TillTipsCalculator></TillTipsCalculator>
    </v-row>
    <v-card>
      <v-tabs show-arrows slider-color="primary" v-model="active">
        <v-tab>Balancements</v-tab>
        <v-tab>Dépôts</v-tab>
        <v-tab-item>
          <v-card-text class="pt-0">
            <TillHistoryGrid :loading="loading"></TillHistoryGrid>
          </v-card-text>
        </v-tab-item>
        <v-tab-item>
          <v-card-text class="pt-0">
            <TillDepositGrid :loading="loading"></TillDepositGrid>
          </v-card-text>
        </v-tab-item>
      </v-tabs>
    </v-card>
  </v-container>
</template>

<script>
import {
  TillSettings,
  TillDepositGrid,
  TillHistoryGrid,
  TillTipsCalculator
} from "../components";
import { mapGetters } from "vuex";
export default {
  name: "TillIndex",
  components: {
    TillSettings,
    TillHistoryGrid,
    TillDepositGrid,
    TillTipsCalculator
  },
  computed: {
    ...mapGetters(["getStoreId"])
  },
  async beforeRouteEnter(to, from, next) {
    next(async vm => {
      await vm.getData();
    });
  },
  async beforeRouteUpdate() {
    await this.getData();
  },
  data() {
    return {
      loading: true,
      active: 0
    };
  },
  methods: {
    async getData() {
      try {
        this.loading = true;
        await this.$store.dispatch("loadTills");
        await this.$store.dispatch("loadDeposits");
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style lang="scss"></style>
